export default "__VITE_ASSET__Dij4gu6n__"